import EventListContainer from './EventListContainer'

export default EventListContainer
